<template>
  <div>
    <div id="blankView" v-show="!isStatServiceEnabled">
      <div class="restricted-box">
        <div class="restricted-icon">
          <img src="../../assets/img/icon_find_stat.png" alt="검색 통게표 아이콘" width="64" height="64" />
        </div>
        <p class="restricted-title">조회된 통계표가 없습니다.</p>
        <p class="restricted-desc">검색 조건을 변경하신 후 다시 시도해 주세요.</p>
      </div>
    </div>
    <div id="subjectView" v-show="isStatServiceEnabled">
      <div class="layout">
        <div class="tit-location">
        <div class="sub-tit">
          <h2>{{ currentSubjectName }}</h2>
        </div>
        <div class="navTitle">
          <div>{{ naviPath }}</div>
        </div>
      </div>
        <!-- 공통 탭 -->
        <ul class="tab-btn-list align-start">
          <li
            :class="{on: commonTabs === 0 || commonTabs === 4 || commonTabs === 5 || commonTabs === 6 || commonTabs === 7}">
            <a class="tab router-link" @click="goList()">통계표</a>
          </li>
          <li :class="{on: commonTabs === 1}" v-show="isStatReportShow"><a class="tab router-link" @click="goStatReportList()">통계보고서</a></li>
          <li :class="{on: commonTabs === 2}" v-show="hasMdss"><a class="tab router-link" @click="goMdssList()">MDSS</a></li>
          <li :class="{on: commonTabs === 3}" v-show="isMetaInfoShow"><a class="tab router-link" @click="goMetaInfo()">메타정보</a></li>
        </ul>
        <!-- 통계표 목록 상단 바 -->
        <div class="stat-type-wrap" style="overflow: hidden" v-show="commonTabs !== 1 && commonTabs !== 2 && commonTabs !== 3">
          <button type="button" v-show="commonTabs !== 0" class="btn-stats-all" @click="showMenuList()">통계표 목록</button>
          <div class="stat-type-head align-end type02">
            <div class="stat-search-box">
              <label class="ir" for="searchKeyword">검색창</label>
              <input type="search" v-model="searchText" v-on:keyup.enter="searchKeyword" id="searchKeyword">
              <button type="submit" @click="searchKeyword">검색</button>
            </div>
            <button type="button" class="default btn mt5" @click="showKeywordSearch()">명칭검색</button>
            <button type="button" class="default btn mt5 mobile-hidden" @click="showDetailSearch()">상세검색</button>
          </div>
          <div class="stat-type-header" style="display: none;">
            <h3>통계표</h3>
          </div>
          <div id="depDiv">
            <ul class="tab-btn-list align-start" style="display: none;">
              <li :class="{on : selectedSubjectId === '01'}"><button type="button" @click.prevent="selectTopMenu('STBL-1014250','01')">문화</button></li>
              <li :class="{on : selectedSubjectId === '02'}"><button type="button" @click.prevent="selectTopMenu('STBL-1030638','02')">예술</button></li>
              <li :class="{on : selectedSubjectId === '03'}"><button type="button" @click.prevent="selectTopMenu('STBL-1014252','03')">콘텐츠</button></li>
              <li :class="{on : selectedSubjectId === '04'}"><button type="button" @click.prevent="selectTopMenu('STBL-1014253','04')">관광</button></li>
              <li :class="{on : selectedSubjectId === '05'}"><button type="button" @click.prevent="selectTopMenu('STBL-1014255','05')">스포츠</button></li>
              <li :class="{on : selectedSubjectId === '06'}"><button type="button" @click.prevent="selectTopMenu('STBL-1030639','06')">종합</button></li>
            </ul>
          </div>

          <!-- 통계표 목록 -->
          <div v-show="commonTabs === 0 || statPopup === 'Y'" :class="{stat_list_popup : statPopup === 'Y'}">
          <ul class="stat-type-list align-start type02" style="border:1px solid #c3cfd8 !important">
            <!--
            <li :class="{lastDepth01: depthClass === 1}">
              <ul class="stat-depth02">
                <li v-for="(data, idx) in statisticsListData" v-bind:key="idx"
                    :class="{on : selected1DepthMenu === data.menuId, result: isMcstStatistics(data)}"
                    style="cursor: pointer"
                    @click.prevent="selectStatMenu(1, data)">
                  <a>{{ data.title }}</a>
                  <a v-show="isKosisStatistics(data)" class="btn-new-window">새 창</a>
                </li>
              </ul>
            </li>
            -->
            <li v-show="depth2Yn" :class="{lastDepth02: depthClass === 2}">
              <ul class="stat-depth02">
                <li v-for="(data, idx) in static2depthListData" v-bind:key="idx"
                    :class="{on : selected2DepthMenu === data.menuId, result: isMcstStatistics(data)}"
                    style="cursor: pointer"
                    @click.prevent="selectStatMenu(2, data)">
                  <a>{{ data.title }}</a>
                  <a v-show="isKosisStatistics(data)" class="btn-new-window">새 창</a>
                </li>
              </ul>
            </li>
            <li v-show="depth3Yn" :class="{lastDepth03: depthClass === 3}">
              <ul class="stat-depth02">
                <li v-for="(data, idx) in static3depthListData" v-bind:key="idx"
                    :class="{on : selected3DepthMenu === data.menuId, result: isMcstStatistics(data)}"
                    style="cursor: pointer"
                    @click.prevent="selectStatMenu(3, data)">
                  <a>{{ data.title }}</a>
                  <a v-show="isKosisStatistics(data)" class="btn-new-window">새 창</a>
                </li>
              </ul>
            </li>
            <li v-show="depth4Yn" :class="{lastDepth04: depthClass === 4}">
              <ul class="stat-depth02">
                <li v-for="(data, idx) in static4depthListData" v-bind:key="idx"
                    :class="{on : selected4DepthMenu === data.menuId, result: isMcstStatistics(data)}"
                    style="cursor: pointer"
                    @click.prevent="selectStatMenu(4, data)">
                  <a>{{ data.title }}</a>
                  <a v-show="isKosisStatistics(data)" class="btn-new-window">새 창</a>
                </li>
              </ul>
            </li>
            <li v-show="depth5Yn" :class="{lastDepth05: depthClass === 5}">
              <ul class="stat-depth02">
                <li v-for="(data, idx) in static5depthListData" v-bind:key="idx"
                    :class="{on : selected5DepthMenu === data.menuId, result: isMcstStatistics(data)}"
                    style="cursor: pointer"
                    @click.prevent="selectStatMenu(5, data)">
                  <a>{{ data.title }}</a>
                  <a v-show="isKosisStatistics(data)" class="btn-new-window">새 창</a>
                </li>
              </ul>
            </li>
          </ul>
          </div>

          <!-- 통계표 상세보기 -->
          <div v-show="commonTabs === 4">
            <div v-show="!isFullScreen" class="stat-type-content-inner">
              <swiper class="swiper" :options="swiperOption">
                <!-- 통계표 탭영역 -->
                <swiperSlide v-for="(tab, index) in tabs" v-bind:key="index" :class="{on: currentTab === index}">
                  <a @click="changeStatisticsByTab(tab.menuId, index, tab.subjectId, tab.subItemId, tab)" style="cursor: pointer" :title="tab.title">{{ tab.title }}</a>
                  <button type="button" class="tab-close" @click="removeTab(index)">닫기</button>
                </swiperSlide>
                <!-- 통계표 탭영역 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
            <!-- 통계표명 중복으로 삭제 -->
            <div class="align-between stat-option" v-if="tabs && tabs.length && tabs[currentTab]" style="display:none">
              <h4 class="btn-area-title">{{ selectedStatistics.tblKorNm }} </h4>
            </div>
            <!-- ibsheet 영역 -->
             <div style="position: relative;">
                 <StblSelector v-for="(item, index) in tabs" v-bind:key="item.sheetIndex"
                            v-show="currentTab === index"
                            :sub-item-id="item.subItemId"
                            :stat-id="item.menuId"
                            :stats-parameters-id="statsParametersId"
                            :item-idx="item.sheetIndex"
                            :infoItem="item">
                 </StblSelector>
            </div>
            <!-- // ibsheet 영역 -->

          </div>

          <!-- 통계표 키워드 검색 결과-->
          <div class="search-result" v-show="commonTabs === 5">
            <SubjectSearchResultView ref="searchResult" :stat-id="statId"
                                     @show-statistics-popup="staticDetail"></SubjectSearchResultView>
          </div>

          <!-- 명칭검색 -->
          <div class="search-result-wrap" v-show="commonTabs === 6">
            <SubjectInitialSearchView ref="initialSearch" :stat-id="statId"
                                      @show-statistics-popup="staticDetail"></SubjectInitialSearchView>
          </div>

          <!-- 상세검색 -->
          <div v-show="commonTabs === 7">
            <SearchDetail ref="searchDetail" :stat-id="statId" @show-statistics-popup="staticDetail"/>
          </div>

        </div>

        <!-- 메타정보 -->
        <div v-show="commonTabs === 3">
          <MetaInfo ref="metaTab"/>
        </div>
      </div>

      <!-- 통계보고서 -->
      <div v-show="commonTabs === 1">
        <StatReportListItem ref="reportTab" :showClassCode="false"></StatReportListItem>
      </div>

      <!-- MDSS -->
      <div v-show="commonTabs === 2">
        <MDSSBoardView ref="mdssTab" :stat-name="statName"></MDSSBoardView>
      </div>

      <!-- 모달 : 주석 -->
      <div class="modal_cnt" id="modal6" style="display:none;">
        <div class="modal-header">
          <h2>주석</h2>
          <a href="#" class="close_btn"><img src="../../assets/img/popup_close.png" alt="닫기" @click.prevent="closeModal"></a>
        </div>
        <div class="modal-content">
          <p class="remark" v-html="cmmtDesc"></p>
        </div>
      </div>

      <!-- 모달 : 기본정보 -->
      <div class="modal_cnt" id="modal7" style="display:none;">
        <div class="modal-header">
          <h2>기본정보</h2>
          <a href="#" class="close_btn" @click.prevent="closeModal"><img src="../../assets/img/popup_close.png" alt="닫기"></a>
        </div>
        <div class="modal-content">
          <div class="agreement_page02" v-if="staticBasicData != ''" style="display:table;width:100%;">
            <dl class="align-start popup-table">
              <dt style="text-align:center;">통계표명</dt>
              <dd>{{ staticBasicData.tblKorNm }}</dd>
            </dl>
            <dl class="align-start popup-table">
              <dt style="text-align:center;">목록</dt>
              <dd>{{ staticBasicData.pathNm }}</dd>
            </dl>
            <dl class="align-start popup-table">
              <dt style="text-align:center;">조사명</dt>
              <dd>{{ staticBasicData.statKorNm }}</dd>
            </dl>
            <dl class="align-start popup-table">
              <dt style="text-align:center;">입력연도</dt>
              <dd>{{ staticBasicData.tblYearMonth }}</dd>
            </dl>
          </div>
        </div>
      </div>

      <!-- 모달 : 사용법 -->
      <div class="modal_cnt" id="modal8" style="display:none;" :style=imgManualSize>
        <div class="modal-header">
          <h2>사용법</h2>
          <a href="#" class="close_btn" @click.prevent="closeModal"><img src="../../assets/img/popup_close.png" alt="닫기"></a>
        </div>
        <div class="modal-content" style="max-height:550px; overflow:auto;">
          <img :src=imgManualNm width="100%" alt="사용법">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import https from 'https'
import * as api from '../../api/Statistics.js'
import * as menuApi from '@/api/Menu.js'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import $ from 'jquery'
import MetaInfo from '../../components/MetaInfo'
import StatReportListItem from '../../components/StatReportListItem'
import SearchDetail from '../../components/SearchDetail'
import MDSSBoardView from "../../components/page/MDSSBoardView";
import SubjectInitialSearchView from "../../components/page/SubjectInitialSearchView";
import SubjectSearchResultView from "../../components/page/SubjectSearchResultView";
import MainNewContents04 from "../../components/main/contents/MainNewContents04.vue";
import StblView from "../../components/StblView";
import StblIndexView from "../../components/StblIndexView.vue";
import SpinnerSheet from "../../components/SpinnerSheet.vue";
import SubjectNameUtil from "../../assets/js/SubjectNameUtil";
import StblSelector from "@/components/StblSelector";

export default {
  name: 'subjectView',
  components: {
    StblSelector,
    SpinnerSheet,
    MainNewContents04,
    MDSSBoardView,
    SubjectInitialSearchView,
    SubjectSearchResultView,
    swiper,
    swiperSlide,
    MetaInfo,
    StatReportListItem,
    SearchDetail,
    StblView,
    StblIndexView
  },

  props: {
    subItemId: {
      type: String,
      default: ''
    },
    subItemNm: {
      type: String,
      default: ''
    },
    tabId: {
      type: String,
      default: ''
    },
    upMgmNo:{

    }
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 9,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      statId: this.subItemId,
      statName: this.subItemNm,
      lastSubjectId: '', //마지막에 열었던 대메뉴
      lastSubItemId: '', //마지막에 열었던 통계표의 조사ID
      subMenuItems: [],
      subMenuMgmNo: '',
      prevSubMenuMgmNo: true,
      multiStblDepth01List: [], // 1레벨 리스트 : 삭제 예정
      statisticsListData: [], // 1레벨 리스트
      static2depthListData: [],
      static3depthListData: [],
      static4depthListData: [],
      static5depthListData: [],
      depth2Yn: false,
      depth3Yn: false,
      depth4Yn: false,
      depth5Yn: false,
      selectedDepthMenu: 'STBL-1014250',
      selectedSubjectId: '01',
      selected1DepthMenu: '',
      selected2DepthMenu: '',
      selected3DepthMenu: '',
      selected4DepthMenu: '',
      selected5DepthMenu: '',
      cmmtDesc: '',
      staticBasicData: {},
      searchText: '',

      sheetCounter: 0, //IBSheet DOM 생성용 카운터

      commonTabs: 0, // 공통탭 숫자로 제어 (0:통계표, 1:통계보고서, 2:MDSS, 3:메타정보, 4:통계표상세보기, 5:키워드검색, 6:명칭검색, 7:상세검색)
      tabs: [], // 통계표 상세탭
      currentTab: 0, // 통계표 상세탭 제어
      depthClass: 0, // 통계표 목록 마지막 뎁스 확인 (2: 2레벨, 3: 3레벨, 4: 4레벨)


      statsParametersId: '',
      // 상세검색 데이터

      // 통계보고서 데이터
      isStatReportShow: this.subItemId.indexOf("KOSIS") > -1? false : true,
      // 메타정보
      isMetaInfoShow: true,
      // MDSS 데이터
      hasMdss: false,
      $modalCnt: '',
      selected: [],
      imgManualNm: require('../../assets/img/sub_manual.png'),
      imgManualSize: 'width:1000px',
      statPopup:'N', //통계표 팝업으로 노출할 지 않할지 정보

      isStatServiceEnabled: true,
    }
  },
  computed: {

    naviPath() {
      if (this.commonTabs === 4 || this.commonTabs === 0) {
          //return this.$route.matched[0].name + ' > ' + this.$route.meta.baseRouteName + ' > ' + this.currentSubjectName + ' > ' + this.tabs[this.currentTab].tblKorNm; //통계표명까지 노출
          return this.$route.matched[0].name + ' > ' + this.$route.meta.baseRouteName + ' > ' + this.currentSubjectName
      } else {
        const nm = this.$route.name.split(' > ')
        return this.$route.matched[0].name + ' > ' + this.$route.meta.baseRouteName + ' > ' + this.currentSubjectName + ' > ' + nm[1]
      }
    },
    /**
     * 현재 주제명 가져오기
     */
    currentSubjectName() {
      const menu = this.subMenuItems.filter(item => item.mgmNo === this.subItemId).at();
      return menu ? menu.title : '';
    },

    /**
     * 통계표에서 선택된 통계 아이디
     *
     * @returns {string|*}
     */
    selectedStatisticsId() {
      if (this.tabs?.length > 0 && this.tabs[this.currentTab]) {
        return this.tabs[this.currentTab].menuId;
      } else {
        return '';
      }
    },

    /**
     * 통계표에서 선택된 통계
     *
     * @returns {{}|*}
     */
    selectedStatistics() {
      if (this.tabs?.length > 0 && this.tabs[this.currentTab]) {
        return this.tabs[this.currentTab];
      } else {
        return {};
      }
    },

    /**
     * 전체화면 여부
     *
     * @returns {boolean}
     */
    isFullScreen() {
      return this.$route.query?.view === 'fullscreen';
    }
  },

  watch: {
    isFullScreen: {
      immediate: true,
      handler: value => {
        if (value) {
          $('body').addClass('zoom');
        } else {
          $('body').removeClass('zoom');
        }
      }
    }
  },

  created() {
    window.addEventListener('resize', this.manualResize)
    this.manualResize();
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      const fullPath = to.fullPath;

      let chkSubItemId = null
      let chkStatId = null
      if (fullPath.includes('/stat')) {
        chkSubItemId = to.params.subItemId
        chkStatId = to.params.statId
      } else {
        chkSubItemId = to.params.subItemId
        chkStatId = null
      }

      const result =  await api.isStatisticsServiceEnabled( {
        upTblMgmNo: chkSubItemId,
        tblMgmNo: chkStatId
      });

      // 통계표 서비스 여부 확인
      if (result) {
        vm.isStatServiceEnabled = result.data;
        if (!vm.isStatServiceEnabled) {
          return;
        }
      }

      //INFO 통계표
      if (fullPath.includes('/stat')) {
        vm.$data.commonTabs = 4;
        if (vm.$route.query.hasOwnProperty('statsParametersId')) {
          vm.$data.statsParametersId = vm.$route.query.statsParametersId;
        } else {
          vm.$data.statsParametersId = '';
        }

        if( from.name === null ) {
          api.stblInfoList({
            tblMgmNo: to.params.statId
          }).then(result => {
            const info = result.data;
            const selectedSubjectId = vm.getSubjectIdByMgmNo(to.meta.subMenuItemMgmNo);

            //INFO 통계표 탭추가
            //TODO move to updateDisplayInRouter
            vm.$data.tabs = [{
              title: info.tblKorNm,
              menuId: to.params.statId,
              tblKorNm: info.tblKorNm,
              msrUnitNm: info.msrUnitNm,
              cmmtDesc: info.cmmtDesc,
              subItemId: to.params.subItemId,
              subjectId: 'subject' + selectedSubjectId,
              sheetIndex: String(vm.$data.sheetCounter++),
              upPath: info.upPath
            }];

            //INFO 통계표 로그 쌓기
            api.insertAccessLog({stblMgmNo: to.params.statId});
          });
        }
      }

      vm.$data.prevSubMenuMgmNo = to.params.subItemId === from.params.subItemId;

      await vm.updateDisplayInRouter(vm, vm.$data, to, from);

      return true;
    });
},

  async beforeRouteUpdate(to, from, next) {
    const fullPath = to.fullPath;
    if (fullPath.includes('/stat')) {
      this.commonTabs = 4;

      if (to.query.hasOwnProperty('statsParametersId')) {
        this.statsParametersId = to.query.statsParametersId;
      } else {
        this.statsParametersId = '';
      }

    }
    this.prevSubMenuMgmNo = to.params.subItemId === from.params.subItemId;
    await this.updateDisplayInRouter(this, this, to, from);
    next();
  },

  methods: {
    selectTopMenu (menuId, subjectId) {
      if(this.selectedSubjectId === subjectId){
        if(this.commonTabs !== 0){
          this.showMenuList()
        }else if (this.tabs?.length > 0){
          this.commonTabs = 4
        }
      }else{
        this.commonTabs = 0
        this.selectMenu(menuId)
      }
    },

    /**
     * 라우터로 이동 후 화면 업데이트 처리
     * @param scope
     * @param dataScope
     * @param to
     * @param from
     * @returns {Promise<boolean>}
     */
    async updateDisplayInRouter(scope, dataScope, to, from) {
      const fullPath = to.fullPath;

      //INFO LEVEL1 목록 불러오기
      const subItemId = to.params.subItemId;
      dataScope.selected1DepthMenu = to.params.subItemId;

      //INFO Route 내부에서는 await 사용 불가
      dataScope.statisticsListData = [];
      dataScope.static2depthListData = [];
      scope.getStatistics(to.meta.subMenuItemMgmNo).then(level1Data => {
        dataScope.statisticsListData = level1Data.items;
        scope.loadSubMenu(to.meta.subMenuItemMgmNo);
        dataScope.selectedSubjectId = scope.getSubjectIdByMgmNo(to.meta.subMenuItemMgmNo);

        return new Promise(resolve => {
          const level1Item = level1Data.items.filter(item => item.menuId === to.params.subItemId).at();
          if (level1Item.kosisYn === 'Y') {
            scope.getStatisticsForKosis(level1Item.apiKey, level1Item.apiParentId).then(result => {
              resolve(result);
            });
          } else {
            //INFO LEVEL2 목록 불러오기
            scope.getStatistics(subItemId).then(result => {
              resolve(result);
            });
          }
        });
      }).then(level2Data => {
        dataScope.static2depthListData = level2Data.items;
      });


      if (fullPath.includes('/stat')) {
        //INFO 통계표있는경우
        //TODO 통계표
        dataScope.commonTabs = 4;
        dataScope.lastSubjectId = to.meta.subjectId;
        dataScope.lastSubItemId = to.params.subItemId;
      } else if (fullPath.includes('/report')) {
        //INFO 통계보고서
        dataScope.commonTabs = 1;
        scope.$refs.reportTab.reload(to.params.subItemId);
        //to.params.statId
      } else if (fullPath.includes('/mdss')) {
        //INFO MDSS
        dataScope.commonTabs = 2;
        scope.$refs.mdssTab.reload(to.params.subItemId);
      } else if (fullPath.includes('/meta')) {
        //INFO 메타정보
        dataScope.commonTabs = 3;
        scope.$refs.metaTab.reload(to.params.subItemId);
      } else {
        dataScope.selected2DepthMenu = '';
        dataScope.selected3DepthMenu = '';
        dataScope.selected4DepthMenu = '';
        dataScope.selected5DepthMenu = ''

        dataScope.depthClass = 2;
        dataScope.depth1Yn = true;
        dataScope.depth2Yn = true;
        dataScope.depth3Yn = false;
        dataScope.depth4Yn = false;
        dataScope.depth5Yn = false;
        dataScope.commonTabs = 0;
      }

      dataScope.statId = subItemId;
      scope.initMdssTab(subItemId);

      dataScope.searchText = ''  ;
      if(scope.$refs.searchResult){
        scope.$refs.searchResult.initialize();
      }
      if (scope.$refs.searchDetail) {
        scope.$refs.searchDetail.initialize();
      }

      if(subItemId.startsWith("KOSIS")){
        this.hasMdss = false;
        this.isStatReportShow = false;
        this.isMetaInfoShow = false;
      }else {
        this.isMetaInfoShow = true;
        this.isStatReportShow = true;
      }
      return true;
    },

    getSubjectIdByMgmNo(mgmNo) {
      if (mgmNo === 'STBL-1014250') {
        return '01';
      } else if (mgmNo === 'STBL-1030638') {
        return '02';
      } else if (mgmNo === 'STBL-1014252') {
        return '03';
      } else if (mgmNo === 'STBL-1014253') {
        return '04';
      } else if (mgmNo === 'STBL-1014255') {
        return '05';
      } else if (mgmNo === 'STBL-1030639') {
        return '06';
      } else {
        console.error('wrong subItemId in getSubjectIdBySubItemId', mgmNo);
      }
    },

    /**
     * 1레벨 메뉴만
     * @param menuId
     * @param menuNm
     */
    selectMenu (menuId, menuNm) {
      this.selectedDepthMenu = menuId;
      this.categoryNm = menuNm;

      if (menuId === 'STBL-1014250') {
        this.selectedSubjectId = '01';
      } else if (menuId === 'STBL-1030638') {
        this.selectedSubjectId = '02';
      } else if (menuId === 'STBL-1014252') {
        this.selectedSubjectId = '03';
      } else if (menuId === 'STBL-1014253') {
        this.selectedSubjectId = '04';
      } else if (menuId === 'STBL-1014255') {
        this.selectedSubjectId = '05';
      } else if (menuId === 'STBL-1030639') {
        this.selectedSubjectId = '06';
      }

      this.loadSubMenuPromise(menuId).then(items => {
        //INFO 조사 자동 선택
        const firstMenu = items.at();
        const routeName = SubjectNameUtil.getSubjectNameById(menuId);
        this.$router.push({ name: routeName, params: { subItemId: firstMenu.mgmNo } })
      });
    },

    /**
     * 문화셈터 통계표 여부
     */
    isMcstStatistics(menuData) {
      const {kosisYn, lowerLevelYn, uppermenuId} = menuData;
      if(uppermenuId === 'STBL-1014278'){
        return false;
      }else{
        return kosisYn !== 'Y' && lowerLevelYn !== 'Y';
      }
    },

    /**
     * KOSIS 통계표 여부
     * @param menuData
     */
    isKosisStatistics(menuData) {
      const {kosisYn, lowerLevelYn, uppermenuId} = menuData;
      if(uppermenuId === 'STBL-1014278'){
        return true;
      }
      return kosisYn === 'Y' && lowerLevelYn !== 'Y';
    },

    /**
     * MDSS Tab 초기 설정
     *
     * @param statId
     * @returns {Promise<void>}
     */
    initMdssTab(statId) {
      api.selectMdssUpAnlClsId({tblMgmNo: statId}).then(getIdData => {
        this.hasMdss = getIdData.data != null;
      });
    },

    // 사용법 이미지 resize
    manualResize() {
      if (window.innerWidth <= 768) { // 모바일
        this.imgManualNm = require('../../assets/img/sub_manual_m.png')
        this.imgManualSize = ''
      } else if (window.innerWidth > 768 && window.innerWidth <= 1024) { // 태블릿
        this.imgManualNm = require('../../assets/img/sub_manual_t.png')
        this.imgManualSize = ''
      } else { // PC
        this.imgManualNm = require('../../assets/img/sub_manual.png')
        this.imgManualSize = 'width:1000px'
      }
      this.centerPosition()
    },

    /**
     * 서브메뉴 불러오기
     * @deprecated
     * @param statId
     */
    loadSubMenu(statId) {
      const subMenuItem = this.$store.getters.findSubMenu(statId);
      if (subMenuItem) {
        this.subMenuItems = subMenuItem.items;
        return;
      }

      menuApi.searchMenuSubItems({type: 'STBL', upMgmNo: statId }).then(result => {
        this.subMenuItems = result.data;
      });
    },

    /**
     * 서브메뉴 불러오기
     * @param statId
     * @returns {Promise<unknown>}
     */
    loadSubMenuPromise(statId) {
      //TODO 함수명 변경 loadSubMenuPromise -> loadSubMenu
      return new Promise(resolve => {
        const subMenuItem = this.$store.getters.findSubMenu(statId);
        if (subMenuItem) {
          resolve(subMenuItem.items);
          return;
        }

        menuApi.searchMenuSubItems({type: 'STBL', upMgmNo: statId }).then(result => {
          resolve(result.data);
        });
      })
    },

    /**
     * 타이틀 셀렉트 박스 클릭 이벤트
     * @router this.$route.meta.baseRouteName
     * @param subItemId
     * @param subItemNm
     */
    eventClickSubMenuItem(subItemId, subItemNm) {
      this.toggleSubMenu();
      this.$router.push({name: this.$route.meta.baseRouteName, params: {
          subItemId: subItemId,
          subItemNm: subItemNm
        }
      });
    },

    toggleSubMenu() {
      const subMenuItemDiv = this.$refs.subMenuItem;
      if (subMenuItemDiv && subMenuItemDiv.children) {
        if (this.$refs.subMenuList.style.display === 'block') {
          $(subMenuItemDiv.children[0]).stop().slideUp();
        } else {
          $(subMenuItemDiv.children[0]).stop().slideDown();
        }
      }
    },

    // 검색버튼 클릭 시 (키워드 검색)
    searchKeyword() {
      this.commonTabs = 5
      this.$refs.searchResult.search(this.searchText);
    },

    /**
     * 통계표 클릭
     * @router /subject/subject${this.selectedSubjectId}/${this.selected1DepthMenu}
     * @param menuId
     * @param uppermenuId
     * @param lowerLevelYn
     * @param depth
     * @param title
     * @param data
     * @returns {Promise<boolean>}
     */
    async selectStatMenu(depth, data) {
      const {menuId, title, kosisYn, lowerLevelYn, uppermenuId, commentDesc} = data;

      if (kosisYn !== 'Y' && lowerLevelYn !== 'Y' && uppermenuId !== 'STBL-1014278') {
        //통계표 선택
        await this.selectStat(depth, title, menuId);
        return false
      } else if (kosisYn === 'Y' && lowerLevelYn !== 'Y') {
        //KOSIS 통계표 선택
        //INFO KOSIS 통계 팝업
        const url = `https://kosis.kr/statHtml/statHtml.do?orgId=${data.apiOrgId}&tblId=${data.apiTblId}&conn_path=I2`;
        window.open(url);
        return false
      }else if (uppermenuId === 'STBL-1014278'){
        const url = commentDesc;
        window.open(url);
        return false
      }

      const getStatisticsAll = (menuId, data) => {
        if (data.kosisYn === 'Y') {
          return this.getStatisticsForKosis(data.apiKey, data.apiParentId);
        } else {
          return this.getStatistics(menuId);
        }
      }


      if (depth === 1 && lowerLevelYn === 'Y') {
        //INFO LEVEL1은 주소를 변경
        let path = `/subject/subject${this.selectedSubjectId}/${menuId}`;
        await this.$router.push({path: path});

      } else if (depth === 2 && lowerLevelYn === 'Y') {
        const {items, isLowerLevel} = await getStatisticsAll(menuId, data);
        this.depthClass = isLowerLevel ? 3 : 0;
        this.static3depthListData = items;

        this.selected2DepthMenu = menuId
        this.selected3DepthMenu = ''
        this.selected4DepthMenu = ''
        this.selected5DepthMenu = ''
        this.depth3Yn = true
        this.depth4Yn = false
        this.depth5Yn = false
      } else if (depth === 3 && lowerLevelYn === 'Y') {
        const {items, isLowerLevel} = await getStatisticsAll(menuId, data);
        this.depthClass = isLowerLevel ? 4 : 0;
        this.static4depthListData = items;

        this.selected3DepthMenu = menuId
        this.selected4DepthMenu = ''
        this.selected5DepthMenu = ''
        this.depth4Yn = true
        this.depth5Yn = false
      } else if (depth === 4 && lowerLevelYn === 'Y') {
        const {items, isLowerLevel} = await getStatisticsAll(menuId, data);
        this.depthClass = isLowerLevel ? 5 : 0;
        this.static5depthListData = items;

        this.selected4DepthMenu = menuId
        this.selected5DepthMenu = ''
        this.depth5Yn = true
      }

      return true;
    },

    async getStatistics(menuId) {
      return new Promise(async resolve => {
        new Promise(supplierResolve => {
          const data = this.$store.getters.getStatistics(menuId);
          if (data) {
            supplierResolve(data);
          } else {
            api.statisticsList({tblMgmNo: menuId}).then(result => {
              const items = result.data;
              this.$store.commit('statistics', {id:menuId, items:items});
              supplierResolve(items);
            });
          }
        }).then(items => {
          const isLowerLevel = items.some(item => item.lowerLevelYn !== 'Y');
          resolve ({items, isLowerLevel});
        })
      });
    },

    async getStatisticsForKosis(apiKey, apiParentId) {
      let apiUrl;
      let requestData = {
        method: 'getList',
        apiKey: apiKey,
        parentListId: apiParentId
      };

      if (process.env.NODE_ENV === 'development') {
        //INFO 개발환경에서는 KOSIS API를 Stage 서버를 이용, 외부 API는 보안 정책때문에 로컬 개발환경에서는 호출되지 않음.
        apiUrl = 'http://192.168.100.18:8888/portal';
        requestData.httpsAgent = new https.Agent({ rejectUnauthorized: false });
      } else {
        apiUrl = process.env.VUE_APP_SERVER;
      }

      const response = await axios.post(`${apiUrl}/openapi/kosis/proxy`, requestData);
      const items = response.data;
      const isLowerLevel = items.some(item => item.lowerLevelYn !== 'Y');
      return {items, isLowerLevel};
    },

    async selectStat(depth, title, menuId) {
      if (depth === 1) this.selected1DepthMenu = menuId;
      else if (depth === 2) this.selected2DepthMenu = menuId;
      else if (depth === 3) this.selected3DepthMenu = menuId;
      else if (depth === 4) this.selected4DepthMenu = menuId;
      else if (depth === 5) this.selected5DepthMenu = menuId;

      let haveTab = false // 탭이 존재하는지 확인
      let selectTab = 0
      for (const stat of this.tabs) {
        selectTab = selectTab + 1
        if (stat.menuId === menuId) {
          haveTab = true
          this.currentTab = this.tabs.length - selectTab
          break
        }
      }

      if (!haveTab) { // 통계표 탭 생성
        const params = { // 통계표 상세조회 param
          tblMgmNo: menuId
        }
        const staticInfoData = await api.stblInfoList(params)
        let url = ''

        const stat = { // 탭 param
          title: title,
          menuId: menuId,
          tblKorNm: staticInfoData.data.tblKorNm,
          msrUnitNm: staticInfoData.data.msrUnitNm,
          cmmtDesc: staticInfoData.data.cmmtDesc,
          upPath: staticInfoData.data.upPath,
          yearString: staticInfoData.yearString,
          tblYearMonth: staticInfoData.tblYearMonth,
          //subItemId : this.subItemId,
          subItemId : this.selected1DepthMenu,
          subItemNm : this.statName,
          subjectId : 'subject' + this.selectedSubjectId,
          url: url,
          sheetIndex: String(this.sheetCounter++)
        }

        if (this.tabs.length > 4) {
          alert('통계표는 5개까지 열 수 있습니다.');

          //INFO: 경고 이후 메뉴를 닫는다.
          this.commonTabs = 4;
          return false
        }

        //INFO 마지막에 선택한 통계표와 조사가 다르면 탭을 모두 삭제
        if (this.lastSubItemId !== this.subItemId) {
          this.tabs.splice(0, this.tabs.length);
        }

        this.tabs.splice(this.tabs.length, 0, stat);

        const logParam = {
          stblMgmNo: menuId
        }
        await api.insertAccessLog(logParam) // 통계표 로그 쌓기
        this.currentTab = this.tabs.length - 1;
      }

      this.commonTabs = 4;
      this.statPopup = "N";

      let path = `/subject/subject${this.selectedSubjectId}/${this.selected1DepthMenu}/stat/${menuId}`;
      await this.$router.push({path: path});
    },

    /**
     * 탭 선택으로 통계표 이동
     * @router /subject/${subjectId}/${subItemId}/stat/${menuId}
     * @param menuId 메뉴 아아디
     * @param tabIndex 선택한 탭 인덱스
     * @param subjectId
     * @param subItemId
     * @returns {Promise<void>}
     */
    changeStatisticsByTab(menuId, tabIndex, subjectId, subItemId, data) {
      this.currentTab = tabIndex;
      // 탭정보에서 정보 구성
      const path = `/subject/${subjectId}/${subItemId}/stat/${menuId}`;
      const location = {path: path};

      if (this.isFullScreen) {
        location.query = {view: 'fullscreen'};
      }

      this.$router.push(location);
    },

    /**
     * 통계탭 제거하기
     *
     * @router /subject/${subjectId}/${this.subItemId}
     * @param tabIndex
     * @returns {Promise<void>}
     */
    async removeTab(tabIndex) {

      this.tabs.splice(tabIndex, 1);
      if (this.tabs?.length > 0) {
        const to = this.tabs[this.tabs.length - 1];
        this.currentTab = this.tabs.length - 1;
        const subjectId = this.$route.meta.subjectId;
        const path = `/subject/${subjectId}/${this.subItemId}/stat/${to.menuId}`;
        const location = {path: path};

        if (this.isFullScreen)
          location.query = {view: 'fullscreen'};
        await this.$router.push(location);
      } else {
        this.commonTabs = 0;
        let subjectId = this.$route.meta.subjectId;
        let path = `/subject/${subjectId}/${this.subItemId}`;
        await this.$router.push({path: path});
      }
    },

    /**
     * TODO Subject01, MDSSBoardView 둘다 사용하는 듯
     * mdss 모달창 닫기
     */
    closeModal() {
      $('#mask').add(this.$modalCnt).stop().fadeOut('fast', function () {
        $('#mask').remove()
      })
    },


    /**
     * TODO Subject01, MDSSBoardView 둘다 사용하는 듯
     * 모달창 세팅
     */
    setModal(target) {
      // const $openBtn = $(target)
      let $modalCnt = $(target).attr('href')
      $modalCnt = $($modalCnt)
      // const $closeBtn = $modalCnt.find(".close_btn")

      this.$modalCnt = $modalCnt

      $modalCnt.before('<div id="mask"></div>')

      $(window).on('resize', this.centerPosition)

      $('#mask').add($modalCnt).stop().fadeIn('fast')
      $modalCnt.attr('tabIndex', 0).focus()
      $modalCnt.find('a:first, a:last').on('blur', function () {
        setTimeout(function () {
          if (!$modalCnt.find('a').is(':focus')) {
            $modalCnt.find('.close_btn').click()
          }
        }, 10)
      })

      this.centerPosition()
    },

    /**
     * TODO Subject01, MDSSBoardView 둘다 사용하는 듯
     */
    centerPosition() {
      const topPos = ($(window).height() - $(this.$modalCnt).outerHeight()) / 2
      const leftPos = ($(window).width() - $(this.$modalCnt).outerWidth()) / 2

      $(this.$modalCnt).css({top: topPos, left: leftPos})
    },

    // 통계표 새 창 띄우기
    staticDetail(upPath, levelId2, tblMgmNo, cmmtDesc) {
      let subject =  SubjectNameUtil.getSubjectPathByUpPath(upPath);
      if(levelId2 === 'STBL-1014278'){
        window.open(cmmtDesc);
      }else{
        window.open('/portal/subject/' + subject + '/' +levelId2 + '/stat/' + tblMgmNo);
      }
    },

    /**
     * 명칭검색
     */
    showKeywordSearch() {
      this.commonTabs = 6;
      this.$refs.initialSearch.reload();
    },

    // 상세검색 클릭 시
    showDetailSearch() {
      this.commonTabs = 7
    },

    /**
     * 목록 보기
     */
    async showMenuList() {
      if (this.commonTabs === 0) {
          if (this.tabs.length > 0) {
            this.commonTabs = 4;
            this.statPopup = "N";
          }
      } else if (this.commonTabs === 4 /* || this.commonTabs === 5 || this.commonTabs === 6 || this.commonTabs === 7 */) {
        if(this.statPopup === "Y"){
          this.statPopup = "N";
        }else{
          if(!this.depth2Yn) this.depth2Yn = true;
          this.statPopup = "Y";
        }
      }
    },

    /**
     * 통계표 이동
     * @router /subject/${subjectId}/${this.subItemId}/stat/${this.selectedStatisticsId}
     */
    goList() {
      let subjectId = this.$route.meta.subjectId;
      if (this.selectedStatisticsId) {
        let path = `/subject/${subjectId}/${this.subItemId}/stat/${this.selectedStatisticsId}`;
        this.$router.push({path: path});
      } else {
        let path = `/subject/${subjectId}/${this.subItemId}`;
        this.$router.push({path: path});
      }
    },

    /**
     * 통계보고서 이동
     * @router /subject/${subjectId}/${this.subItemId}/report
     */
    goStatReportList() {
      let subjectId = this.$route.meta.subjectId;
      let path = `/subject/${subjectId}/${this.subItemId}/report`;
      this.$router.push({path: path});
    },

    /**
     * MDSS 이동
     * @router /subject/${subjectId}/${this.firstItemMgmNo}/mdss
     */
    goMdssList() {
      let subjectId = this.$route.meta.subjectId;
      if (this.$route.meta.subMenuItemMgmNo === this.subItemId) {
        //INFO 대분류 메뉴로 진입 할 경우 첫번째 항목의 관리번호를 사용
        this.$router.push({path: `/subject/${subjectId}/${this.firstItemMgmNo}/mdss`});
      } else {
        this.$router.push({path: `/subject/${subjectId}/${this.subItemId}/mdss`});
      }
    },

    /**
     * 메타정보 이동
     * @router /subject/${subjectId}/${this.firstItemMgmNo}/meta
     */
    goMetaInfo() {
      let subjectId = this.$route.meta.subjectId;
      if (this.$route.meta.subMenuItemMgmNo === this.subItemId) {
        //INFO 대분류 메뉴로 진입 할 경우 첫번째 항목의 관리번호를 사용
        this.$router.push({path: `/subject/${subjectId}/${this.firstItemMgmNo}/meta`});
      } else {
        this.$router.push({path: `/subject/${subjectId}/${this.subItemId}/meta`});
      }
    },

    changeUrl(url) {
      return url.replace('http://', 'https://')
    }
  }

}
</script>

<style scoped>
.lastDepth01 {
  width: calc(100%);
  border-right: 0;
}

.lastDepth02 {
  width: calc(100% - 255px);
  border-right: 0;
}

.lastDepth03 {
  width: calc(100% - 510px);
  border-right: 0;
}

.lastDepth04 {
  width: calc(100% - 765px);
  border-right: 0;
}

.default.btn.no {
  background-color: #aeaeae;
  border: 1px solid #7d7d7d;
  cursor: default;
}

.swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {
  opacity: .35;
  cursor: auto;
  pointer-events: auto;
}

.mdss-yy .layout {
  display: flex;
  justify-content: flex-start;
}

.chk-box input {
  opacity: 0 !important;
}

input[type="checkbox"]:disabled, button[type="button"]:disabled {
  cursor: not-allowed;
}

.router-link {
  cursor: pointer;
}

#depDiv{
  background-color:#97a8d6;
}

#depDiv li {
  width: 100%;
  text-align:center;
  border-right:1px solid #fff;
  padding:10px 0;
}

#depDiv li.on {
  background-color:#5670bc;
}

#depDiv li button {
  width:100%;
  color:#fff;
  font-size:medium;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAJCAYAAADtj3ZXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDVENzQ4ODlFOTI5MTFFRjg1NTVGQTNBQzJDNjgzNUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDVENzQ4OEFFOTI5MTFFRjg1NTVGQTNBQzJDNjgzNUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowNUQ3NDg4N0U5MjkxMUVGODU1NUZBM0FDMkM2ODM1QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowNUQ3NDg4OEU5MjkxMUVGODU1NUZBM0FDMkM2ODM1QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pvni6tkAAACgSURBVHjajI49CoNAEIXnAl4ihSCkiNgklY2FjY1H8zD2XsWAREIgTQIhxfgePGEjER34mN33s6y5ewRakAPbQa58ZDpwXqDYKBbKcVoKZ/CU8AblSrGU78pfZiMDDxkfUC2KlXRXjnkLAydwDx6opddBkX46d5ZfO4Kbgl/QaHNG+bZWJgkY/HcG6bZVJjHoVbzqbnvL5AA67b+ZSYABAE5wv5rdr9vgAAAAAElFTkSuQmCC) no-repeat calc(100% - 25px)/auto;
}

#depDiv li.on button {
  font-weight:bold;
}

.stat_list_popup{
  position: absolute;
  width: 100%;
  z-index: 100;
  background-color: #fff;
}
.stat_tit_margin{
  margin-bottom: 10px;
}


.restricted-box {
  height: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 32px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  text-align: center;
}

.restricted-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.restricted-title {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  margin: 20px 0 0 0;
}

.restricted-desc {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
</style>
